import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { HttpService } from '../../services/http.service';
import { ConstantService } from '../../services/constant.service';
import { EcondosQuery } from '@api/model/query';
import * as qs from 'qs';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { SystemBroadcast } from '@api/model/system-broadcast';

@Injectable({ providedIn: 'root' })
export class SystemBroadcastService {
  private readonly endpoint: string;

  constructor(
    protected http: HttpService,
    private constantService: ConstantService
  ) {
    this.endpoint = `${this.constantService.getV3Endpoint()}system-broadcasts/`;
  }

  getActive(query?: EcondosQuery): Observable<{ count: number; systemBroadcasts: SystemBroadcast[] }> {
    const params = new HttpParams({ fromString: qs.stringify(query) });
    return this.http.getWithFullResponse(`${this.endpoint}active`, { params }).pipe(
      map((res: any) => ({
        count: res.headers.get('count'),
        systemBroadcasts: res.body
      }))
    );
  }

  updateCount(systemBroadcastId: string, type: 'linkButtonClick') {
    return this.http.put(`${this.endpoint}${systemBroadcastId}/interactions`, { type });
  }
}
